import type { ModuleKey } from '@/access/modules';

/**
 * המודולים מקובצים לפי מה שהם עושים, ולא לפי סדר ההגדרה.
 *
 * רק מפתחות שורש כאן. תת הפיצ'רים מגיעים מהשרת עם ההורה שלהם
 * (טבלת module_features), כדי שפיצול מודול נוסף יהיה שורה
 * בטבלה ולא שינוי בשני קבצים שחייבים להישאר מסונכרנים.
 */
export type ModuleGroup = {
  title: string;
  hint: string;
  keys: ModuleKey[];
};

export const MODULE_GROUPS: ModuleGroup[] = [
  {
    title: 'ליבה',
    hint: 'כיבוי כאן מוריד חלק גדול מהאפליקציה. מתאים רק אם הרשת באמת לא משתמשת בזה.',
    keys: ['messages', 'schedule', 'learning'],
  },
  {
    title: 'תוספות',
    hint: 'אפשר להתחיל בלעדיהם ולהדליק כשהצוות מוכן. אפשר גם להדליק מודול ולכבות בתוכו רק מה שלא רלוונטי.',
    keys: ['ops', 'games', 'sales', 'hr_docs', 'integration'],
  },
  {
    title: 'בינה מלאכותית',
    hint: 'כל פעולה כאן עולה כסף. גם כשהמודול דלוק, התקציב למטה הוא מה שקובע.',
    keys: ['ai_schedule', 'ai_quiz', 'assistant'],
  },
];

/**
 * מה בדיוק נעלם כשמכבים, למי שיש לו מה להוסיף על התווית.
 *
 * חלקי בכוונה: לתת פיצ'ר שהתווית שלו כבר מדויקת ("נהלים
 * וחתימות") אין מה להוסיף, ומשפט שחוזר על עצמו הוא רעש.
 */
export const MODULE_EFFECT: Partial<Record<ModuleKey, string>> = {
  messages: 'ערוצי הודעות, אישורי קריאה ודוח "מי לא קרא"',
  schedule: 'סידור העבודה, האילוצים, ההחלפות וימים סגורים',
  learning: 'הכל שמתחתיו: לומדות, מוצרים ופלנוגרמה',
  ops: 'הכל שמתחתיו: צ׳קליסטים, משימות, ויטרינה, נהלים, בקשות וסקרים',
  games: 'נקודות, פרסים, תחרויות ומצטיינים',
  sales: 'נתוני מכירות, יעדים ושיאים',
  hr_docs: 'מסמכי עובד רגישים',
  integration: 'סנכרון מול מערכת הקופות',
  ai_schedule: 'הצעת סידור משמרות אוטומטית',
  ai_quiz: 'יצירת שאלות לחידון מתוך תוכן הלומדה',
  assistant: 'עוזר שעונה לעובדים על נהלים ומוצרים',
};

export const AI_MODULES: ModuleKey[] = ['ai_schedule', 'ai_quiz', 'assistant'];
